/**
 * Returns the time of day as a string based on the given time.
 * @param time - The time in milliseconds since the Unix epoch. Defaults to the current time.
 * @returns A string representing the time of day: "night", "morning", "afternoon", or "evening".
 */
export function timeOfDayName(time: number = Date.now()): string {
  const date = new Date(time)
  const hours = date.getHours()

  if (hours < 6) {
    return 'night'
  } else if (hours < 12) {
    return 'morning'
  } else if (hours < 18) {
    return 'afternoon'
  } else {
    return 'evening'
  }
}
